import ViewType from 'constants/productViewType';
import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { IDataItems } from 'services/api/category';
import {
  FiltersSelectionInitialValue,
  IFiltersSelection,
} from 'components/molecules/ProductFilter/store/reducer';
import { PropertyFilterType } from 'components/molecules/ProductFilter/configuration';
import { isObjectNullish } from 'utils/objects';
import {
  DataItemParalist,
  ICollectionOutput,
  IListAssignClientsOutput,
  IProductListOutput,
} from 'services/api/product';
import * as PointofinterestServices from 'services/api/pointofinterest';
import { AddNewEnum } from '../configuration';
import {
  IFavoritesData,
  IClientCollectionsData,
  ICustomersMiniProfileData,
} from 'services/api/client';
import * as ProductService from 'services/api/product';
import { IFetchGoogleSearchPlaceOutput } from 'services/api/google';
import * as PointOfInterestCategoryServices from 'services/api/pointofinterestcategory';
import _ from 'lodash';

export interface IState {
  products: {
    status: StateStatus | null;
    data: IProductListOutput | null;
  };
  addProduct: StateStatus | null;
  insertProductFilter: {
    status: StateStatus | null;
  };
  category: {
    status: StateStatus | null;
    data: Array<IDataItems>;
  };
  filtersSelection: IFiltersSelection;
  published: number;
  isCollapse: boolean;
  addToFavourite: {
    status: StateStatus | null;
  };
  pointSelect: {
    lat: number;
    lng: number;
  } | null;
  paralist: {
    status: StateStatus | null;
    data: Array<DataItemParalist>;
  };
  listPOIs: {
    status: StateStatus | null;
    data: PointofinterestServices.IPointofInterestListOutput | null;
  };
  removeFromFavourite: {
    status: StateStatus | null;
  };
  saveSearch: {
    status: StateStatus | null;
  };
  addClientRequest: {
    status: StateStatus | null;
  };
  addPOI: {
    status: StateStatus | null;
  };
  editPOI: {
    status: StateStatus | null;
  };
  deletePOI: {
    status: StateStatus | null;
  };
  selectAddNew: AddNewEnum | null;
  customerName: {
    status: StateStatus | null;
    data: any;
  };
  propertyName: {
    status: StateStatus | null;
    data: any;
  };
  addNewTask: {
    status: StateStatus | null;
  };
  uploadFileTask: {
    data: any;
    status: StateStatus | null;
  };
  statusLane: {
    status: StateStatus | null;
    data: any;
  };
  favoritesData: {
    status: StateStatus | null;
    data: IFavoritesData | null;
  };
  customers: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  customersByRole: {
    data: Array<ProductService.IMiniProfile>;
    status: StateStatus | null;
  };
  addAssignClients: {
    status: StateStatus | null;
  };
  addCollections: {
    status: StateStatus | null;
  };
  addSharingProduct: {
    status: StateStatus | null;
  };
  clientCollectionsPersonal: {
    status: StateStatus | null;
    data: IClientCollectionsData | null;
  };
  sharing: {
    status: StateStatus | null;
    data: any;
  };
  assignees: {
    status: StateStatus | null;
    data: any;
  };
  listVieweds: {
    status: StateStatus | null;
    data: ProductService.IViewedListOutput[] | null;
  };
  sendMail: {
    status: StateStatus | null;
    data: any;
  };
  sendMailAdvance: {
    status: StateStatus | null;
    data: any;
  };
  sendCloneProduct: {
    status: StateStatus | null;
    data: any;
  };
  polygonDraw: any[] | null;
  googleSearchPlace: {
    status: StateStatus | null;
    data: IFetchGoogleSearchPlaceOutput[] | null;
  };
  collectionByGuid: {
    status: StateStatus | null;
    data: ICollectionOutput | null;
  };
  listPOICategory: {
    status: StateStatus | null;
    data: PointOfInterestCategoryServices.IPointOfInterestCategoryListOutput | null;
  };
  addPOICategory: {
    status: StateStatus | null;
  };
  clientMiniProfiles: {
    status: StateStatus | null;
    data: ICustomersMiniProfileData | null;
  };
  documents: {
    status: StateStatus | null;
    data: Array<any>;
  };
  mapZoomLevel: number | null;
  deletePropertyFromCollection: {
    status: StateStatus | null;
  };
  assignClientsCollections: {
    data: IListAssignClientsOutput['data'];
    status: StateStatus | null;
  };
}

export const initialState: IState = {
  products: {
    status: null,
    data: null,
  },
  addProduct: null,
  category: {
    status: null,
    data: [],
  },
  filtersSelection: FiltersSelectionInitialValue,
  published: 2,
  isCollapse: false,
  addToFavourite: {
    status: null,
  },
  removeFromFavourite: {
    status: null,
  },
  pointSelect: null,
  paralist: {
    status: null,
    data: [],
  },
  listPOIs: {
    status: null,
    data: null,
  },
  saveSearch: {
    status: null,
  },
  addClientRequest: {
    status: null,
  },
  addPOI: {
    status: null,
  },
  editPOI: {
    status: null,
  },
  insertProductFilter: {
    status: null,
  },
  deletePOI: {
    status: null,
  },
  selectAddNew: null,
  addNewTask: {
    status: null,
  },
  customerName: {
    status: null,
    data: null,
  },
  propertyName: {
    status: null,
    data: null,
  },
  uploadFileTask: {
    data: null,
    status: null,
  },
  statusLane: {
    status: null,
    data: null,
  },
  favoritesData: {
    status: null,
    data: null,
  },
  customers: {
    data: [],
    status: null,
  },
  customersByRole: {
    data: [],
    status: null,
  },
  addAssignClients: {
    status: null,
  },
  addCollections: {
    status: null,
  },
  addSharingProduct: {
    status: null,
  },
  clientCollectionsPersonal: {
    status: null,
    data: null,
  },
  sharing: {
    status: null,
    data: null,
  },
  sendMail: {
    status: null,
    data: null,
  },
  sendMailAdvance: {
    status: null,
    data: null,
  },
  sendCloneProduct: {
    status: null,
    data: null,
  },
  assignees: {
    status: null,
    data: null,
  },
  listVieweds: {
    status: null,
    data: null,
  },
  polygonDraw: null,
  googleSearchPlace: {
    status: null,
    data: null,
  },
  collectionByGuid: {
    status: null,
    data: null,
  },
  listPOICategory: {
    status: null,
    data: null,
  },
  addPOICategory: {
    status: null,
  },
  clientMiniProfiles: {
    status: null,
    data: null,
  },
  documents: {
    status: null,
    data: [],
  },
  mapZoomLevel: null,
  deletePropertyFromCollection: {
    status: null,
  },
  assignClientsCollections: {
    data: [],
    status: null,
  },
};

const ProductReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_LIST:
      return {
        ...state,
        products: {
          ...state.products,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.products.data
              : action.data.page === 0
              ? action.data.data
              : {
                  paging: action.data?.data?.paging,
                  items: [
                    ...(state.products.data?.items
                      ? state.products.data?.items
                      : []),
                    ...(action.data.data?.items ? action.data.data?.items : []),
                  ],
                },
        },
        // ...(action.data.data && action.data.data.filters
        //   ? {
        //       filtersSelection: {
        //         ...FiltersSelectionInitialValue,
        //         fetch: false,
        //         [PropertyFilterType.PropertyType]: {
        //           ...state.filtersSelection[PropertyFilterType.PropertyType],
        //           isChecked: !isObjectNullish({
        //             ...state.filtersSelection[PropertyFilterType.PropertyType]
        //               .data,
        //             ...action.data.data.filters[
        //               PropertyFilterType.PropertyType
        //             ],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.PropertyType]
        //               .data,
        //             ...action.data.data.filters[
        //               PropertyFilterType.PropertyType
        //             ],
        //           },
        //         },
        //         [PropertyFilterType.Location]: {
        //           ...state.filtersSelection[PropertyFilterType.Location],
        //           isChecked: !isObjectNullish({
        //             ...state.filtersSelection[PropertyFilterType.Location].data,
        //             ...action.data.data.filters[PropertyFilterType.Location],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.Location].data,
        //             ...action.data.data.filters[PropertyFilterType.Location],
        //           },
        //         },
        //         [PropertyFilterType.Other]: {
        //           ...state.filtersSelection[PropertyFilterType.Other],
        //           isChecked: !isObjectNullish({
        //             ...action.data.data.filters[PropertyFilterType.Other],
        //           }),
        //           data: {
        //             ...state.filtersSelection[PropertyFilterType.Other].data,
        //             ...action.data.data.filters[PropertyFilterType.Other],
        //           },
        //         },
        //       },
        //     }
        //   : {}),
      };
    case Types.SET_ADD_PRODUCT:
      return {
        ...state,
        addProduct: action.status ?? null,
      };
    case Types.SET_PUBLISHED:
      return {
        ...state,
        published: action.data ?? 2,
      };
    case Types.SET_COLLAPSE:
      return {
        ...state,
        isCollapse: action.data ?? false,
      };
    case Types.SET_CATEGORY:
      return {
        ...state,
        category: {
          ...state.category,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_FILTERS_SELECTION:
      return {
        ...state,
        filtersSelection: {
          ...action.data,
          fetch: true,
        },
      };
    case Types.ADD_TO_FAVOURITE:
      return {
        ...state,
        addToFavourite: {
          ...state.addToFavourite,
          status: action.status || null,
        },
        ...(action.status === StateStatus.Success
          ? {
              products: {
                ...state.products,
                data: {
                  ...(state.products.data as any),
                  items: action.data.products,
                },
              },
            }
          : {}),
      };
    case Types.REMOVE_FROM_FAVOURITE:
      return {
        ...state,
        removeFromFavourite: {
          ...state.removeFromFavourite,
          status: action.status || null,
        },
        ...(action.status === StateStatus.Success
          ? {
              products: {
                ...state.products,
                data: {
                  ...(state.products.data as any),
                  items: action.data.products,
                },
              },
            }
          : {}),
      };
    case Types.SET_POINT_SELECT:
      return {
        ...state,
        pointSelect: action.data,
      };
    case Types.SET_PARALIST:
      return {
        ...state,
        paralist: {
          ...state.paralist,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_POI_LIST:
      return {
        ...state,
        listPOIs: {
          ...state.listPOIs,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME ? state.listPOIs.data : action.data,
        },
      };
    case Types.SAVE_SEARCH:
      return {
        ...state,
        saveSearch: {
          ...state.saveSearch,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_CLIENT_REQUEST:
      return {
        ...state,
        addClientRequest: {
          ...state.addClientRequest,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_POI:
      return {
        ...state,
        addPOI: {
          ...state.addPOI,
          status: action.status || null,
        },
      };
    case Types.SET_EDIT_POI:
      return {
        ...state,
        editPOI: {
          ...state.editPOI,
          status: action.status || null,
        },
      };
    case Types.SET_DELETE_POI:
      return {
        ...state,
        deletePOI: {
          ...state.deletePOI,
          status: action.status || null,
        },
      };
    case Types.INSERT_PRODUCT_FILTER:
      return {
        ...state,
        insertProductFilter: {
          ...state.insertProductFilter,
          status: action.status || null,
        },
      };
    case Types.SET_SELECT_ADD_NEW:
      return {
        ...state,
        selectAddNew: action.data,
      };

    case Types.ADD_NEW_TASK:
      return {
        ...state,
        addNewTask: {
          ...state.addNewTask,
          status: action.status || null,
        },
      };
    case Types.SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: {
          ...state.customerName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_PROPERTY_NAME:
      return {
        ...state,
        propertyName: {
          ...state.propertyName,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPLOAD_FILE_TASK:
      return {
        ...state,
        uploadFileTask: {
          ...state.uploadFileTask,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_STATUS_LANE:
      return {
        ...state,
        statusLane: {
          ...state.statusLane,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_FAVORITES:
      return {
        ...state,
        favoritesData: {
          ...state.favoritesData,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMERS:
      return {
        ...state,
        customers: {
          ...state.customers,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CUSTOMERS_BY_ROLE:
      return {
        ...state,
        customersByRole: {
          ...state.customersByRole,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_ADD_ASSIGN_CLIENTS:
      return {
        ...state,
        addAssignClients: {
          ...state.addAssignClients,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_COLLECTIONS:
      return {
        ...state,
        addCollections: {
          ...state.addCollections,
          status: action.status || null,
        },
      };
    case Types.SET_ADD_SHARING_PRODUCT:
      return {
        ...state,
        addSharingProduct: {
          ...state.addSharingProduct,
          status: action.status || null,
        },
      };
    case Types.SET_ASSIGNESS:
      return {
        ...state,
        assignees: {
          ...state.assignees,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CLIENT_COLLECTION_PERSONAL:
      return {
        ...state,
        clientCollectionsPersonal: {
          ...state.clientCollectionsPersonal,
          status: action.status ?? null,
          data: action.data,
        },
      };
    case Types.SET_SHARING_PRODUCT:
      return {
        ...state,
        sharing: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_LIST_VIEWED:
      return {
        ...state,
        listVieweds: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SEND_EMAIL_PRODUCT:
      return {
        ...state,
        sendMail: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SEND_EMAIL_ADVANCE_PRODUCT:
      return {
        ...state,
        sendMailAdvance: {
          data: action.data,
          status: action.status || null,
        },
      };

    case Types.SEND_CLONE_PRODUCT:
      return {
        ...state,
        sendCloneProduct: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SET_POLYGON_DRAW:
      return {
        ...state,
        polygonDraw: action.data,
      };
    case Types.SET_GOOGLE_SEARCH_PLACE:
      return {
        ...state,
        googleSearchPlace: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.GET_COLLECTION_BY_GUID:
      return {
        ...state,
        collectionByGuid: {
          ...state.collectionByGuid,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.GET_LIST_POI_CATEGORY:
      return {
        ...state,
        listPOICategory: {
          ...state.listPOICategory,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.RESET_DATA_COLLECTION:
      return {
        ...state,
        collectionByGuid: {
          status: null,
          data: null,
        },
      };
    case Types.SET_ADD_POI_CATEGORY:
      return {
        ...state,
        addPOICategory: {
          ...state.addPOICategory,
          status: action.status || null,
        },
      };

    case Types.SET_CLIENTS_MINI_PROFILES:
      return {
        ...state,
        clientMiniProfiles: {
          ...state.clientMiniProfiles,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SET_PRODUCT_DOCUMENT:
      return {
        ...state,
        documents: {
          ...state.documents,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? [...state.documents.data]
              : _.uniqBy(
                  [...state.documents.data, ...action.data],
                  (item) => item?.['id']
                ),
        },
      };
    case Types.RESET_DOCUMENT:
      return {
        ...state,
        documents: {
          status: null,
          data: [],
        },
      };

    case Types.SET_MAP_ZOOM_LEVEL:
      return {
        ...state,
        mapZoomLevel: action.data,
      };
    case Types.DELETE_PROPERTY_FROM_COLLECTION:
      return {
        ...state,
        deletePropertyFromCollection: {
          status: action.status || null,
        },
      };
    case Types.SET_ASSIGN_CLIENTS_PRODUCTS:
      return {
        ...state,
        assignClientsCollections: {
          ...state.assignClientsCollections,
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default ProductReducer;
